import type { Monitoring } from '../../../shared/timing';

export type SourceKind = 'demo' | 'file' | 'mic' | 'tab';

export interface AudioSource {
  readonly kind: SourceKind;
  readonly label: string;
  /** The node to analyse (and, for app-monitored sources, to play). */
  readonly node: AudioNode;
  /** 'app' when we play the sound ourselves (so we can delay it to match the picture). */
  readonly monitoring: Monitoring;
  readonly inputLatencyS: number;
  readonly canPause: boolean;
  readonly playing: boolean;
  start(): Promise<void> | void;
  stop(): void;
  togglePlay?(): void;
  /** Called when the source ends on its own (file finished, tab sharing stopped). */
  onEnded: (() => void) | null;
}

export class SourceError extends Error {
  constructor(
    message: string,
    readonly userMessage: string,
  ) {
    super(message);
  }
}
